const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        page: {
          title: "Indicadores de atendimento",
          subtitleAll: "Visão geral de todos os atendimentos da operação.",
          subtitleOwn: "Seus indicadores de atendimento.",
          period: {
            label: "Período",
            today: "Hoje",
            last7: "Últimos 7 dias",
            last30: "Últimos 30 dias",
            month: "Mês atual",
            custom: "Personalizado",
            from: "De",
            to: "Até",
          },
          filters: {
            queue: "Fila",
            allQueues: "Todas as filas",
            attendant: "Atendente",
            allAttendants: "Todos os atendentes",
          },
          errors: {
            invalidDates: "Informe datas válidas.",
            endBeforeStart: "A data final deve ser igual ou posterior à inicial.",
            tooLong: "O período máximo é de 366 dias.",
          },
          cards: {
            conversations: "conversas medidas",
            open: { label: "Em atendimento agora", hint: "Tickets abertos neste momento, independentemente do período." },
            pending: { label: "Aguardando agora", hint: "Tickets na fila esperando alguém aceitar, neste momento." },
            unanswered: { label: "Sem resposta", hint: "Tickets do período em que o cliente escreveu e ninguém respondeu ainda." },
            created: { label: "Atendimentos iniciados", hint: "Tickets criados no período. Uma conversa reaberta no mesmo ticket não conta de novo. Grupos não entram." },
            closed: { label: "Resolvidos", hint: "Tickets finalizados dentro do período." },
            firstResponse: { label: "1ª resposta (média)", hint: "Tempo entre a primeira mensagem do cliente e a primeira mensagem enviada por nós. Respostas do agente automático contam. Tickets iniciados por nós não entram." },
            handling: { label: "Tempo de atendimento (aprox.)", hint: "Da criação do ticket até a última atualização dos tickets resolvidos no período. É uma aproximação: qualquer alteração depois de resolvido altera o número." },
            ratings: "avaliações",
            rating: { label: "Nota média", hint: "Média das notas (1 a 5) dadas pelos clientes nos atendimentos resolvidos no período. Só conta quem responde à avaliação." },
            ratingRate: { label: "Respostas à avaliação", hint: "Dos atendimentos resolvidos no período em que a avaliação foi pedida, quantos clientes responderam." },
            newContacts: { label: "Novos contatos", hint: "Contatos cadastrados no período (sem grupos)." },
          },
          charts: {
            byHour: "Início dos atendimentos por hora do dia",
            ratings: "Notas recebidas",
            closeReasons: "Motivos de encerramento",
            perDay: "Atendimentos iniciados por dia",
            perQueue: "Por fila",
            perAttendant: "Por atendente",
          },
          table: {
            rating: "Nota",
            attendant: "Atendente",
            created: "Iniciados",
            closed: "Resolvidos",
            firstResponse: "1ª resposta (média)",
          },
          noReason: "Sem motivo",
          noRatings: "Nenhuma avaliação neste período.",
          noQueue: "Sem fila",
          noAttendant: "Sem atendente (na fila)",
          empty: "Nenhum atendimento neste período.",
        },
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          botEnabled: "Agente Rose ativo nesta conexão",
          ignoreGroups: "Ignorar grupos do WhatsApp",
          farewellMessage: "Mensagem de despedida"
        },
        hours: {
          enabled: "Definir horário de atendimento",
          help: "Fora do horário, a Rose continua atendendo e avisa que a equipe responde no expediente. Sem a Rose, o cliente recebe o aviso abaixo (uma vez a cada 12 horas).",
          timezone: "Fuso horário",
          closed: "Fechado",
          holidays: "Feriados e dias sem atendimento",
          holidaysHelp: "Uma data por linha, no formato AAAA-MM-DD (ex.: 2026-12-25).",
          message: "Aviso fora do horário",
          messageHelp: "Enviado ao cliente que escreve fora do expediente. Deixe vazio para não enviar aviso. Aceita {{name}}.",
          days: { 0: "Domingo", 1: "Segunda", 2: "Terça", 3: "Quarta", 4: "Quinta", 5: "Sexta", 6: "Sábado" },
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        noPhone: "Sem telefone",
        lidHint: "LID: identificador interno do WhatsApp, usado quando o telefone não é revelado.",
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      hermes: {
        handoffReason: {
          cliente: "Rose: o cliente pediu uma pessoa",
          modelo: "Rose: o agente passou para a equipe",
          erro: "Rose: o agente falhou e passou para a equipe",
          ventana: "Rose: tempo de resposta esgotado",
          hostilidade: "Rose: cliente irritado, atenção",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        lidOnlyHint: "O campo acima guarda o LID, não um telefone. Informe o telefone real com DDI e DDD para identificar o contato.",
        lidHint: "Identificador interno do WhatsApp, mantido junto ao telefone.",
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        botHeader: "Bot",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
          peek: "Espiar conversa",
        },
        peek: {
          subtitle: "Espiando (somente leitura, o cliente não vê que você abriu)",
          close: "Fechar",
          empty: "Sem mensagens",
          loading: "Carregando…",
          latest: "Mostrando as últimas mensagens",
          customer: "Cliente",
          team: "Bot / equipe",
          media: "[mídia]",
          deleted: "mensagem apagada",
          noQueue: "Sem fila",
          botActive: "Bot ativo",
          waiting: "Em espera",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      lab: {
        title: "Laboratório da Rose",
        hint: "Clientes simulados conversam com a Rose num ambiente de teste (nada é enviado pelo WhatsApp e nenhum atendimento real é alterado). Cada cenário é avaliado por critérios fixos: se transferiu, o motivo, o que a resposta contém e o tamanho. Rode antes e depois de mudar o agente.",
        scenarios: "Cenários",
        results: "Resultados",
        builtin: "padrão",
        noRuns: "Nenhum teste rodado ainda.",
        pickOne: "Marque ao menos um cenário.",
        turnsCount: "{{count}} mensagem(ns) do cliente",
        running: "Rodando… {{done}} de {{total}} cenários",
        summary: "{{passed}} de {{total}} cenários passaram",
        customer: "Cliente",
        agent: "Rose",
        handedOff: "Transferiu para a equipe",
        scenarioSaved: "Cenário salvo.",
        scenarioDeleted: "Cenário excluído.",
        deleteTitle: "Excluir cenário",
        deleteMessage: "Este cenário será removido. Os resultados antigos continuam salvos.",
        status: { pass: "Passou", fail: "Falhou", error: "Erro" },
        handoff: { any: "Transferir é indiferente", required: "Deve transferir", forbidden: "Não deve transferir" },
        hours: { open: "Horário: aberto", closed: "Horário: fechado (simulado)", real: "Horário real da conexão" },
        reason: { cliente: "Cliente pediu", modelo: "Agente decidiu", erro: "Erro", ventana: "Tempo esgotado", hostilidade: "Hostilidade" },
        buttons: { new: "Novo cenário", run: "Rodar selecionados", duplicate: "Duplicar", save: "Salvar", cancel: "Cancelar" },
        modal: {
          titleNew: "Novo cenário",
          titleEdit: "Editar cenário",
          name: "Nome",
          turns: "Mensagens do cliente",
          turnsHelp: "Uma por linha (até 6). Se a Rose transferir, as seguintes não são enviadas.",
          hours: "Horário de atendimento simulado",
          hoursHelp: "Informado à Rose junto com a mensagem.",
          expectTitle: "O que esperar da Rose",
          handoff: "Transferência para a equipe",
          reasonsHelp: "Motivos aceitos se transferir (vazio = qualquer):",
          mustContain: "A resposta deve conter",
          mustNotContain: "A resposta não pode conter",
          termsHelp: "Um termo por linha; ignora maiúsculas e acentos.",
          minReplies: "Mín. respostas",
          maxReplies: "Máx. respostas",
          maxReplyChars: "Máx. caracteres",
          timeout: "Espera (s)",
        },
      },
      campaigns: {
        title: "Campanhas",
        hint: "Disparos em massa com intervalo aleatório entre mensagens, limite por hora e janela de horário. Envie apenas para quem aceitou receber contato.",
        empty: "Nenhuma campanha ainda. Crie a primeira para começar.",
        optOutNotice: "Para não receber mais mensagens, responda SAIR.",
        buttons: {
          add: "Nova campanha",
          details: "Detalhes",
          start: "Iniciar",
          pause: "Pausar",
          resume: "Retomar",
          cancel: "Cancelar campanha",
          delete: "Excluir",
          close: "Fechar",
          review: "Revisar",
          keepDraft: "Deixar como rascunho",
        },
        table: {
          name: "Nome",
          status: "Situação",
          progress: "Progresso",
          sent: "Enviadas",
          remaining: "Restantes",
          actions: "Ações",
        },
        status: {
          draft: "Rascunho",
          running: "Enviando",
          paused: "Pausada",
          completed: "Concluída",
          canceled: "Cancelada",
        },
        recipientStatus: {
          pending: "Na fila",
          sent: "Enviada",
          failed: "Falhou",
          invalid: "Sem WhatsApp",
          skipped: "Ignorada",
        },
        toasts: {
          started: "Campanha iniciada.",
          deleted: "Campanha excluída.",
        },
        confirm: {
          cancel: {
            title: "Cancelar a campanha",
            message: "As mensagens que ainda não foram enviadas serão descartadas. O que já foi enviado não pode ser desfeito.",
          },
          delete: {
            title: "Excluir a campanha",
            message: "O histórico de envios desta campanha será apagado.",
          },
        },
        details: {
          estimate: "tempo restante estimado: {{time}} (sem contar a janela de horário)",
          finished: "finalizada",
          message: "Mensagem",
          settings: "Intervalo de {{min}} a {{max}} s entre mensagens · até {{hourly}} por hora",
          window: "somente das {{start}} às {{end}}",
          started: "Início",
          finishedAt: "Fim",
          filter: "Mostrar",
          all: "Todos",
          name: "Nome",
          number: "Número",
          status: "Situação",
          sentAt: "Enviada em",
          more: "Carregar mais",
        },
        modal: {
          title: "Nova campanha",
          reviewTitle: "Revisar antes de enviar",
          name: "Nome da campanha",
          connection: "Conexão que vai enviar",
          connectionOffline: "Esta conexão não está conectada agora. O envio só começa quando ela estiver.",
          audience: "Quem recebe",
          audienceAll: "Todos os contatos (exceto grupos e quem pediu para sair)",
          audienceContacts: "Escolher contatos",
          audienceTag: "Contatos com uma etiqueta",
          chooseTag: "Escolha a etiqueta",
          noTags: "Nenhuma etiqueta criada. Crie em Contatos > Etiquetas.",
          audienceNumbers: "Colar uma lista de números",
          searchContacts: "Buscar contatos",
          noContacts: "Nenhum contato encontrado",
          numbersHint: "Um por linha: só o número, ou nome;número. Números sem código de país são tratados como do Brasil (55).",
          message: "Mensagem",
          messageHint: "Use [[firstName]] ou [[name]] e variações como {Olá|Oi|E aí}",
          preview: "Prévia (exemplo)",
          optOutNotice: "Adicionar aviso para sair (\"responda SAIR\") no fim da mensagem",
          pace: "Ritmo de envio",
          minDelay: "Pausa mínima (s)",
          maxDelay: "Pausa máxima (s)",
          hourlyLimit: "Máx. por hora",
          paceHint: "A pausa entre mensagens é sorteada entre o mínimo e o máximo (mínimo permitido: {{min}} s). Ritmo mais lento reduz o risco de bloqueio do número.",
          useWindow: "Enviar somente em um horário",
          windowStart: "Das",
          windowEnd: "Até",
          scheduledAt: "Começar em (opcional)",
          scheduledHint: "Em branco: começa assim que você iniciar.",
        },
        review: {
          ready: "{{count}} destinatários prontos para receber.",
          optOut: "{{count}} ignorados porque pediram para não receber mensagens.",
          invalid: "{{count}} linhas/contatos com número inválido foram ignorados.",
          duplicates: "{{count}} repetidos foram ignorados.",
          estimate: "Tempo estimado: {{time}} (sem contar a janela de horário).",
          warning: "Depois de iniciar, as mensagens já enviadas não podem ser desfeitas. Você pode pausar ou cancelar a qualquer momento.",
        },
        optOutBadge: "Não quer receber campanhas",
        optOutOn: "Marcar para não receber campanhas",
        optOutOff: "Voltar a receber campanhas",
      },
      tags: {
        title: "Etiquetas",
        manage: "Etiquetas",
        filter: "Etiqueta",
        filterAll: "Todas",
        contactTitle: "Etiquetas do contato",
        select: "Etiquetas",
        noneCreated: "Nenhuma etiqueta criada ainda. Um administrador cria em Contatos > Etiquetas.",
        newName: "Nova etiqueta",
        editName: "Nome da etiqueta",
        empty: "Nenhuma etiqueta ainda.",
        contactsCount: "{{count}} contato",
        contactsCount_plural: "{{count}} contatos",
        confirmDelete: "Excluir a etiqueta \"{{name}}\"? Ela será removida de todos os contatos.",
        toasts: {
          deleted: "Etiqueta excluída.",
        },
        buttons: {
          add: "Adicionar",
          save: "Salvar",
          cancelEdit: "Cancelar edição",
          close: "Fechar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          campaigns: "Campanhas",
          lab: "Laboratório",
          schedules: "Agendamentos",
          supervisor: "Supervisor",
          protocols: "Protocolos",
          funnel: "Funil",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
          darkMode: "Modo escuro",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      funnel: {
        title: "Funil de oportunidades",
        new: "Nova oportunidade",
        search: "Buscar oportunidade ou contato",
        owner: "Responsável",
        allOwners: "Todos",
        noOwner: "Sem responsável",
        emptyStage: "Nenhuma oportunidade nesta etapa.",
        truncated: "Mostrando as {{total}} mais recentes. Use a busca para ver as demais.",
        menu: "Opções",
        moveTo: "Mover para {{stage}}",
        delete: "Excluir",
        deleted: "Oportunidade excluída.",
        confirmDeleteTitle: "Excluir oportunidade",
        confirmDeleteMessage: "A oportunidade e suas tarefas serão removidas. O atendimento e o contato não são afetados.",
        kind: {"open": "Em andamento", "won": "Ganha", "lost": "Perdida"},
        summary: {
          open: "{{total}} em aberto",
          openValue: "Em aberto: {{total}}",
          won: "{{total}} ganhas",
          wonValue: "Ganho: {{total}}",
          rate: "Taxa de ganho: {{total}}%",
          noRate: "Taxa de ganho: sem dados",
        },
        card: {"overdue": "{{total}} atrasada(s)", "tasks": "{{total}} tarefa(s)"},
        alerts: {
          button: "Alertas ({{total}})",
          taskOverdue: "Tarefa atrasada",
          stale: "Parada",
          days: "{{total}} dia(s) na etapa",
        },
        dialog: {
          newTitle: "Nova oportunidade",
          editTitle: "Oportunidade",
          title: "Título",
          contact: "Contato",
          contactHint: "Digite ao menos 3 letras do nome ou número",
          pickContact: "Escolha o contato da oportunidade.",
          value: "Valor (R$)",
          stage: "Etapa inicial",
          firstStage: "Primeira etapa",
          owner: "Responsável",
          me: "Eu",
          notes: "Observações",
          openTicket: "Abrir atendimento",
          saved: "Oportunidade salva.",
          cancel: "Cancelar",
          save: "Salvar",
        },
        tasks: {
          title: "Tarefas",
          empty: "Nenhuma tarefa. Registre o próximo passo para não perder o prazo.",
          new: "Nova tarefa",
          due: "Prazo",
          add: "Adicionar",
          remove: "Remover tarefa",
          noDue: "Sem prazo",
          overdue: "Atrasada",
        },
        stages: {
          button: "Etapas",
          title: "Etapas do funil",
          hint: "Etapas \"em andamento\" podem avisar quando uma oportunidade fica parada além do prazo. Etapas \"ganha\" e \"perdida\" encerram a oportunidade.",
          name: "Nome",
          color: "Cor",
          kind: "Tipo",
          staleDays: "Alertar após (dias)",
          save: "Salvar",
          saved: "Etapa salva.",
          up: "Subir",
          down: "Descer",
          remove: "Excluir etapa",
          add: "Adicionar etapa",
          newName: "Nova etapa",
          close: "Fechar",
        },
      },
      protocols: {
        title: "Protocolos e avaliações",
        export: "Exportar CSV",
        truncated: "A exportação foi limitada às {{rows}} linhas mais recentes. Use os filtros para reduzir.",
        summary: { total: "Encerrados", rated: "Avaliados", average: "Nota média", low: "Notas 1 e 2" },
        hintAdmin: "Atendimentos encerrados, com protocolo, motivo e nota do cliente. A data de encerramento é aproximada (última atualização do atendimento). Notas 1 e 2 aparecem em destaque para acompanhamento.",
        hintOwn: "Seus atendimentos encerrados, com protocolo, motivo e nota do cliente.",
        search: "Buscar protocolo ou contato",
        filters: {
          from: "Encerrado de",
          to: "Até",
          rating: "Nota",
          anyRating: "Qualquer",
          reason: "Motivo",
          allReasons: "Todos",
          noReason: "Sem motivo",
          queue: "Fila",
          allQueues: "Todas",
          noQueue: "Sem fila",
          attendant: "Atendente",
          allAttendants: "Todos",
          connection: "Conexão",
          allConnections: "Todas",
        },
        ratingFilter: { rated: "Avaliados", unrated: "Sem avaliação", low: "Baixas (1 e 2)", "5": "Nota 5", "4": "Nota 4", "3": "Nota 3", "2": "Nota 2", "1": "Nota 1" },
        table: { protocol: "Protocolo", contact: "Contato", attendant: "Atendente", queue: "Fila", reason: "Motivo", rating: "Nota", closedAt: "Encerrado em", actions: "Ações" },
        empty: "Nenhum atendimento encerrado com esses filtros.",
        openTicket: "Abrir atendimento",
        perPage: "Por página",
      },
      supervisor: {
        title: "Supervisor",
        hint: "Atendimentos abertos e aguardando, do mais parado ao mais recente. Marque os que quer tratar e use as ações em massa (até {{max}} por vez). Nada é enviado ao cliente por estas ações.",
        search: "Buscar contato ou mensagem",
        summary: { open: "Em atendimento", pending: "Aguardando" },
        status: { open: "Em atendimento", pending: "Aguardando" },
        filters: {
          status: "Situação",
          allStatus: "Todas",
          queue: "Fila",
          allQueues: "Todas",
          noQueue: "Sem fila",
          attendant: "Atendente",
          allAttendants: "Todos",
          noAttendant: "Sem atendente",
          connection: "Conexão",
          allConnections: "Todas",
          idle: "Parados há",
          anyIdle: "Qualquer tempo",
          idleAtLeast: "Pelo menos {{time}}",
          unread: "Só com não lidas",
        },
        table: {
          contact: "Contato",
          lastMessage: "Última mensagem",
          status: "Situação",
          attendant: "Atendente",
          queue: "Fila",
          idle: "Parado há",
          actions: "Ações",
        },
        nobody: "Ninguém",
        empty: "Nenhum atendimento com esses filtros.",
        openTicket: "Abrir atendimento",
        selectPage: "Selecionar todos desta página",
        selected: "{{total}} selecionado(s) (máx. {{max}})",
        clear: "Limpar seleção",
        limit: "Limite de {{max}} atendimentos por vez.",
        perPage: "Por página",
        result: "{{done}} concluído(s), {{skipped}} ignorado(s), {{failed}} com falha.",
        transfer: {
          user: "Atendente de destino",
          noUser: "Nenhum (voltar para a fila)",
          queue: "Fila de destino",
          keepQueue: "Manter a fila atual",
          help: "Com atendente, o atendimento passa para \"Em atendimento\". Só com fila, volta para \"Aguardando\" nessa fila.",
        },
        actions: {
          transfer: {
            button: "Transferir",
            title: "Transferir {{total}} atendimento(s)",
            description: "Escolha o atendente e/ou a fila. Cada atendimento recebe uma nota interna registrando a transferência.",
            confirm: "Transferir",
          },
          unassign: {
            button: "Devolver à fila",
            title: "Devolver {{total}} atendimento(s) à fila",
            description: "Os atendimentos ficam sem atendente e voltam para \"Aguardando\", na mesma fila.",
            confirm: "Devolver",
          },
          close: {
            button: "Resolver",
            title: "Resolver {{total}} atendimento(s)",
            description: "Os atendimentos são encerrados sem mensagem de despedida e sem pedido de avaliação ao cliente. Se ele escrever depois, volta para a fila normalmente.",
            confirm: "Resolver",
          },
          markRead: {
            button: "Marcar como lido",
            title: "Marcar {{total}} atendimento(s) como lido(s)",
            description: "Zera as mensagens não lidas no painel. Não envia confirmação de leitura ao cliente.",
            confirm: "Marcar como lido",
          },
        },
      },
      schedules: {
        title: "Agendamentos",
        hintAdmin: "Todas as mensagens agendadas da equipe. Mensagens aguardando envio podem ser canceladas; as que falharam podem ser reenviadas. Para agendar, use o relógio dentro do atendimento.",
        hintOwn: "Mensagens que você agendou. Para agendar, use o relógio dentro do atendimento.",
        search: "Buscar por contato, número ou texto",
        filters: {
          status: "Status",
          all: "Todos",
          connection: "Conexão",
          allConnections: "Todas",
          createdBy: "Agendado por",
          everyone: "Todos",
          from: "De",
          to: "Até",
        },
        table: {
          contact: "Contato",
          message: "Mensagem",
          sendAt: "Envio",
          status: "Status",
          connection: "Conexão",
          createdBy: "Agendado por",
          actions: "Ações",
        },
        empty: "Nenhuma mensagem agendada com esses filtros.",
        openTicket: "Abrir atendimento",
        retry: "Tentar de novo",
        cancel: "Cancelar envio",
        confirmCancelTitle: "Cancelar este agendamento?",
        canceled: "Agendamento cancelado.",
        retried: "Mensagem na fila para envio.",
      },
      schedule: {
        title: "Agendar mensagem",
        message: "Mensagem",
        when: "Enviar em",
        repeat: "Repetir",
        hint: "A mensagem sai pela conexão deste atendimento. Se a conexão estiver offline, o sistema tenta de novo por até 3 vezes.",
        saved: "Mensagem agendada.",
        list: "Agendadas neste atendimento",
        empty: "Nenhuma mensagem agendada.",
        close: "Fechar",
        save: "Agendar",
        status: {
          pending: "Aguardando",
          sent: "Enviada",
          failed: "Falhou",
          canceled: "Cancelada",
        },
        recurrence: {
          none: "Uma vez",
          daily: "Todo dia",
          weekly: "Toda semana",
          monthly: "Todo mês",
        },
        followUpEnabled: "Follow-up automático quando o cliente para de responder",
        followUpAfter: "Minutos de silêncio (mín. 30)",
        followUpMax: "Máx. de follow-ups (1 a 3)",
        followUpMessage: "Mensagem de follow-up",
        followUpHelp: "Use {{name}} para o nome. Só envia dentro do horário de atendimento, em atendimentos sem bot, e para quando o cliente responder ou pedir SAIR. Vazio usa o texto padrão.",
      },
      quality: {
        closeTitle: "Encerrar atendimento",
        reason: "Motivo do encerramento",
        reasonRequired: "Obrigatório: escolha um motivo para encerrar.",
        reasonOptional: "Opcional: escolha um motivo ou encerre sem.",
        reasonNone: "Sem motivo",
        confirm: "Encerrar",
        cancel: "Cancelar",
        notes: "Notas internas",
        notesHint: "Visíveis só para a equipe. O cliente não recebe.",
        notesPlaceholder: "Escreva uma nota...",
        notesAdd: "Adicionar",
        notesEmpty: "Nenhuma nota ainda.",
        notesClose: "Fechar",
        protocol: "Protocolo",
        rating: "Avaliação",
        settingsTitle: "Qualidade do atendimento",
        requireReason: "Exigir motivo ao encerrar",
        reasonsTitle: "Motivos de encerramento",
        reasonName: "Novo motivo",
        reasonAdd: "Adicionar",
        reasonInactive: "inativo",
        reasonHide: "Desativar",
        reasonShow: "Reativar",
        reasonDelete: "Excluir",
        ratingEnabled: "Pedir avaliação (1 a 5) ao encerrar",
        ratingMessage: "Mensagem de avaliação",
        ratingHelp: "Use {{protocol}} para o protocolo e {{name}} para o nome. Vazio usa o texto padrão.",
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            botOn: "Bot ligado",
            botOff: "Bot desligado",
            botTurnOff: "Desligar o bot e assumir a conversa",
            botTurnOn: "Ligar o bot neste atendimento",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_FUNNEL_TITLE: "Informe o título da oportunidade (até 120 caracteres).",
        ERR_FUNNEL_VALUE: "Informe um valor válido, a partir de zero.",
        ERR_FUNNEL_NOTES: "As observações podem ter até 2000 caracteres.",
        ERR_FUNNEL_DUE: "Informe uma data e hora válidas.",
        ERR_FUNNEL_COLOR: "Escolha uma cor válida.",
        ERR_FUNNEL_KIND: "Tipo de etapa inválido.",
        ERR_FUNNEL_STALE_DAYS: "Informe entre 1 e 365 dias, ou deixe em branco.",
        ERR_FUNNEL_STAGE_NAME: "Informe o nome da etapa (até 60 caracteres).",
        ERR_FUNNEL_STAGE_NOT_FOUND: "Etapa não encontrada.",
        ERR_FUNNEL_STAGE_HAS_OPPORTUNITIES: "Mova as oportunidades desta etapa antes de excluí-la.",
        ERR_FUNNEL_LAST_OPEN_STAGE: "O funil precisa ter ao menos uma etapa em andamento.",
        ERR_FUNNEL_REORDER: "Não foi possível reordenar as etapas. Atualize a página.",
        ERR_OPPORTUNITY_NOT_FOUND: "Oportunidade não encontrada.",
        ERR_TASK_NOT_FOUND: "Tarefa não encontrada.",
        ERR_TASK_TITLE: "Informe o título da tarefa (até 160 caracteres).",
        ERR_TASK_DONE: "Valor inválido para conclusão da tarefa.",
        ERR_SCHEDULE_INVALID_BODY: "Escreva a mensagem (até 4000 caracteres).",
        ERR_SCHEDULE_INVALID_DATE: "Informe uma data e hora válidas.",
        ERR_SCHEDULE_PAST: "Escolha um horário pelo menos 1 minuto à frente.",
        ERR_SCHEDULE_TOO_FAR: "O agendamento pode ser de até 1 ano.",
        ERR_SCHEDULE_INVALID_RECURRENCE: "Repetição inválida.",
        ERR_SCHEDULE_NOT_FOUND: "Agendamento não encontrado.",
        ERR_SCHEDULE_NOT_PENDING: "Só é possível cancelar mensagens aguardando envio.",
        ERR_SCHEDULE_NOT_FAILED: "Só é possível tentar de novo mensagens que falharam.",
        ERR_BULK_EMPTY: "Selecione ao menos um atendimento.",
        ERR_BULK_LIMIT: "Selecione no máximo 200 atendimentos por vez.",
        ERR_BULK_INVALID_ACTION: "Ação inválida.",
        ERR_BULK_TARGET_REQUIRED: "Escolha um atendente ou uma fila de destino.",
        ERR_BULK_INVALID_TARGET: "Atendente ou fila de destino não encontrado.",
        ERR_CLOSE_REASON_REQUIRED: "Escolha o motivo do encerramento.",
        ERR_CLOSE_REASON_INVALID: "Motivo de encerramento inválido ou desativado.",
        ERR_CLOSE_REASON_INVALID_NAME: "Informe um nome de até 80 caracteres.",
        ERR_CLOSE_REASON_DUPLICATED: "Já existe um motivo com esse nome.",
        ERR_CLOSE_REASON_NOT_FOUND: "Motivo não encontrado.",
        ERR_NOTE_INVALID: "Escreva a nota (até 2000 caracteres).",
        ERR_NOTE_NOT_FOUND: "Nota não encontrada.",
        ERR_TAG_NOT_FOUND: "Etiqueta não encontrada.",
        ERR_TAG_NAME_IN_USE: "Já existe uma etiqueta com esse nome.",
        ERR_TAG_INVALID_NAME: "Informe o nome da etiqueta (até 40 caracteres).",
        ERR_TAG_TOO_MANY: "Limite de 20 etiquetas por contato.",
        ERR_CAMPAIGN_NOT_FOUND: "Campanha não encontrada.",
        ERR_CAMPAIGN_INVALID_STATE: "Esta ação não é possível na situação atual da campanha.",
        ERR_CAMPAIGN_CONNECTION_BUSY: "Já existe outra campanha enviando por esta conexão. Pause ou conclua a outra antes.",
        ERR_CAMPAIGN_NO_RECIPIENTS: "Nenhum destinatário válido para esta campanha.",
        ERR_CAMPAIGN_NO_RECIPIENTS_OPT_OUT: "Todos os contatos escolhidos pediram para não receber campanhas.",
        ERR_LAB_INVALID_NAME: "Informe um nome para o cenário.",
        ERR_LAB_INVALID_TURNS: "Informe de 1 a 6 mensagens do cliente (até 500 caracteres cada).",
        ERR_LAB_INVALID_EXPECT: "Confira os critérios do cenário.",
        ERR_LAB_NOT_FOUND: "Registro do laboratório não encontrado.",
        ERR_LAB_RUN_BUSY: "Já existe um teste em andamento.",
        ERR_LAB_NO_SCENARIOS: "Nenhum cenário selecionado.",
        ERR_HERMES_NOT_CONFIGURED: "A integração com a Rose não está configurada (HERMES_WEBHOOK_URL).",
        ERR_BUSINESS_HOURS_INVALID: "Horário de atendimento inválido.",
        ERR_BUSINESS_HOURS_TIMEZONE: "Fuso horário inválido.",
        ERR_BUSINESS_HOURS_TIME: "Horários inválidos: use HH:MM e abertura antes do fechamento.",
        ERR_BUSINESS_HOURS_HOLIDAY: "Feriados inválidos: use datas reais no formato AAAA-MM-DD.",
        ERR_BUSINESS_HOURS_NO_DAYS: "Marque ao menos um dia de atendimento.",
        ERR_CAMPAIGN_TOO_MANY_RECIPIENTS: "Destinatários demais para uma campanha (máximo 5000).",
        ERR_CAMPAIGN_INVALID_NAME: "Informe um nome para a campanha.",
        ERR_CAMPAIGN_INVALID_MESSAGE: "Informe a mensagem (até 3000 caracteres).",
        ERR_CAMPAIGN_INVALID_CONNECTION: "Conexão inválida.",
        ERR_CAMPAIGN_INVALID_SETTINGS: "Confira o ritmo de envio: pausas e limite por hora fora do permitido.",
        ERR_CAMPAIGN_DELAY_TOO_LOW: "A pausa mínima entre mensagens é de 15 segundos.",
        ERR_CAMPAIGN_INVALID_WINDOW: "Confira o horário: preencha início e fim diferentes (formato HH:MM).",
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_NO_TICKET_ACCESS: "Você não tem acesso a este atendimento.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
      },
    },
  },
};

export { messages };
